<template>
	<div>
		<div class="flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
			<WSubTitle text="Performance ratio — PR / APR / PPR" />
			<span class="text-sm text-color-secondary">Hourly</span>
		</div>
		<div v-if="!hourly.length" class="dash-empty">
			<i class="mdi mdi-chart-timeline-variant dash-empty-icon" />
			<p>No PPM hourly results for this period.</p>
		</div>
		<div v-else>
			<apexchart
				type="line"
				height="280"
				:options="chartOptions"
				:series="chartSeries"
			/>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import { DashboardPpmHourly } from '@/brokers/DashboardBroker'

	export default defineComponent({
		name: 'DashChartPr',
		props: {
			hourly: {
				type: Array as PropType<DashboardPpmHourly[]>,
				default: () => [],
			},
		},
		computed: {
			chartSeries(): Array<{ name: string; data: Array<{ x: number; y: number | null }> }> {
				const pts = this.hourly || []
				return [
					{
						name: 'PR',
						data: pts.map((p) => ({ x: new Date(p.hour_start).getTime(), y: p.pr })),
					},
					{
						name: 'APR',
						data: pts.map((p) => ({ x: new Date(p.hour_start).getTime(), y: p.apr })),
					},
					{
						name: 'PPR',
						data: pts.map((p) => ({ x: new Date(p.hour_start).getTime(), y: p.ppr })),
					},
				]
			},
			chartOptions(): Record<string, unknown> {
				return {
					chart: {
						type: 'line',
						height: 280,
						zoom: { type: 'x', enabled: true, autoScaleYaxis: true },
						toolbar: { autoSelected: 'zoom' },
					},
					colors: ['#0f766e', '#2563eb', '#d97706'],
					stroke: { curve: 'smooth', width: 2 },
					dataLabels: { enabled: false },
					markers: { size: 0 },
					yaxis: {
						title: { text: 'Ratio' },
						labels: {
							formatter: (v: number) =>
								v == null ? '' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 3 }),
						},
					},
					xaxis: { type: 'datetime' },
					tooltip: { shared: true, x: { format: 'dd MMM yyyy HH:mm' } },
					legend: { position: 'top' },
				}
			},
		},
	})
</script>

<style scoped>
	.dash-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2rem 1rem;
		color: var(--text-color-secondary);
		gap: 0.5rem;
		border: 1px dashed var(--surface-border);
		border-radius: 6px;
	}
	.dash-empty-icon {
		font-size: 2rem;
		opacity: 0.5;
	}
</style>
